import DownVectorImg from "../../Resources/CommonTable/down Vector.png";
import EnterVectorImg from "../../Resources/CommonTable/enter vector.png";
import CrossImage from "../../Resources/CommonTable/cross.png";
import UpVectorImg from "../../Resources/CommonTable/up Vector.png";
import FilterIcon from "../../Resources/Images/filter-lines.png";
import { useEffect, useRef, useState } from "react";
import { ClickAwayListener } from "@mui/material";
import { DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker as DatePickerRange } from "antd";
import { TextField } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import moment from "moment";
import { Button } from "@mui/material";

const FilterBox = ({
  filterData,
  type,
  handleClearAllState,
  handleSaveAllFilter,
  handleClearSingleFilter,
  handleButtonClick,
  selectedButton,
  autoApply = true,
  // false: with autoApply off, picking (or un-picking) a value does not run handleSaveAllFilter by itself;
  // only the Search button does. The default keeps what every other page has always had.
  searchOnPick = true,
  horizontalLayout = false,
  hideHeader = false,
  hideInput = false,
  alwaysOpen = false,
  hideActionButtons = false,
  customActionButtons = null,
  hideDefaultButtons = false,
  // handleButtonClick,
}) => {
  const { RangePicker } = DatePickerRange;
  const dropDown = {
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
    6: false,
    7: false,
    8: false,
    9: false,
    10: false,
  };
  const [openDataMenu, setOpenDataMenu] = useState(dropDown);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedData, setSelectedData] = useState([]);

  // const[type,setType]=useState("multi")
  const [commonData, setCommonData] = useState([]);
  const [clearView, setClearView] = useState(dropDown);
  const inputsObj = {
    1: null,
    2: null,
    3: null,
    4: null,
    5: null,
    6: null,
    7: null,
    8: null,
    9: null,
    10: null,
  };
  const [inputValues, setInputValues] = useState(inputsObj);

  const [existViw, setExistView] = useState(() => {
    const initial = {
      1: false,
      2: false,
      3: false,
      4: false,
      5: false,
      6: false,
      7: false,
      8: false,
      9: false,
      10: false,
    };
    if (alwaysOpen) {
      Object.keys(initial).forEach((key) => {
        initial[key] = true;
      });
    }
    return initial;
  });

  const [filteredData, setFilteredData] = useState([]);
  const isUserActionRef = useRef(false);
  const [isCardOpen, setIsCardOpen] = useState(false);

  const markUserAction = () => {
    isUserActionRef.current = true;
  };

  const handleInputValues = (e, id) => {
    markUserAction();
    setInputValues((prev) => ({
      ...prev,
      [id]: e?.target?.value,
    }));
  };
  const handleOnChange = (e, id) => {
    markUserAction();
    const currentValue = e.target.value;

    if (!currentValue.trim()) {
      setClearView((prev) => ({
        ...prev,
        [id]: false,
      }));
    } else {
      setClearView((prev) => ({
        ...prev,
        [id]: true,
      }));
    }
    setOpenDataMenu((prev) => ({
      ...prev,
      [id]: true,
    }));
    const existData = commonData?.find((item) => item?.id === id);

    if (!existData) return;

    const updatedData = existData?.data?.filter((ele) =>
      ele?.label
        ?.toLocaleLowerCase()
        ?.includes(currentValue?.toLocaleLowerCase() || "")
    );

    setFilteredData((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, data: updatedData } : item
      )
    );
  };
  const handleOnEnter = (e, setState) => {
    markUserAction();
    setState(e.target.value.trim());
  };
  const handleSelectData = (row, setState, id, variation) => {
    markUserAction();
    if (variation === "single") {
      // Check current state first
      const currentSelected = selectedData.find((itm) => itm?.id === id);
      const isCurrentlySelected = currentSelected?.selectedData?.some(
        (it) => it._id === row?._id
      );

      if (isCurrentlySelected) {
        // Deselect: remove the item
        setSelectedData((prev) =>
          prev.map((itm) =>
            itm?.id === id
              ? {
                ...itm,
                selectedData: [],
              }
              : itm
          )
        );
        setState(null);
        // Clear the input value when deselecting
        setInputValues((prev) => ({
          ...prev,
          [id]: null,
        }));
        // Don't call handleSaveAllFilter here if autoApply is true
        // The useEffect will handle it when selectedData changes
        // Only call directly if autoApply is false (manual mode)
        if (handleSaveAllFilter && !autoApply && searchOnPick) {
          setTimeout(() => {
            handleSaveAllFilter();
          }, 200);
        }
      } else {
        // Select: add the item
        setSelectedData((prev) =>
          prev.some((itm) => itm?.id === id)
            ? prev.map((itm) =>
              itm?.id === id
                ? {
                  ...itm,
                  selectedData: [row],
                }
                : itm
            )
            : [...prev, { id, selectedData: [row] }]
        );
        setState(row?._id);
        // Clear the input value when selecting so the label shows
        setInputValues((prev) => ({
          ...prev,
          [id]: null,
        }));
        // Don't call handleSaveAllFilter here if autoApply is true
        // The useEffect will handle it when selectedData changes
        // Only call directly if autoApply is false (manual mode)
        if (handleSaveAllFilter && !autoApply && searchOnPick) {
          setTimeout(() => {
            handleSaveAllFilter();
          }, 200);
        }
      }

      setOpenDataMenu(dropDown);
    } else {
      setSelectedData((prev) => {
        const existingItem = prev.find((itm) => itm?.id === id);
        const isSelected = existingItem?.selectedData?.some(
          (it) => it._id === row?._id
        );

        if (existingItem) {
          return prev.map((itm) =>
            itm?.id === id
              ? {
                ...itm,
                selectedData: isSelected
                  ? itm.selectedData.filter((it) => it._id !== row?._id)
                  : [...itm.selectedData, row],
              }
              : itm
          );
        } else {
          return [...prev, { id, selectedData: [row] }];
        }
      });

      setState((prev) => {
        let arr;
        if (!prev) {
          arr = [];
        } else {
          arr = [...prev];
        }
        console.log("prevprev", arr);
        return arr?.includes(row?._id)
          ? arr?.filter((id) => id !== row?._id)
          : [...arr, row?._id];
      });

      setOpenDataMenu(dropDown);
    }
  };

  const handleRemoveData = (row, id, setState) => {
    markUserAction();
    setSelectedData((prev) =>
      prev.map((itm) =>
        itm?.id === id
          ? {
            ...itm,
            selectedData: itm.selectedData.filter(
              (el) => el?._id !== row?._id
            ),
          }
          : itm
      )
    );
    setState((prev) => {
      if (!prev) return [];
    });
  };

  const handleOpenClose = (item) => {
    setExistView((prev) => ({
      ...prev,
      [item.id]: !prev[item.id],
    }));

    setClearView((prev) => ({
      ...prev,
      [item.id]: false,
    }));

    setInputValues((prev) => ({
      ...prev,
      [item.id]: null,
    }));

    setOpenDataMenu(dropDown);
  };

  const handleClear = (id) => {
    markUserAction();
    setInputValues((prev) => ({
      ...prev,
      [id]: null,
    }));
  };

  const handleClearAll = () => {
    markUserAction();
    setSelectedData([]);
    setInputValues(inputsObj);
    handleClearAllState();
  };

  const handleDateChange = (date, id, setDate) => {
    markUserAction();
    setDate(date);
    setInputValues((prev) => ({
      ...prev,
      [id]: date,
    }));
  };

  const handleDateChangeDefaultNoDate = (date, id, setDate) => {
    markUserAction();
    setDate(date);
    setInputValues((prev) => ({
      ...prev,
      [id]: date,
    }));
  };

  const truncateText = (text, length = 15) => {
    if (text.length > length) {
      return text.slice(0, length) + "....";
    }
    return text;
  };

  const handleDataSizing = (item) => {
    const data = selectedData?.find((d) => d?.id === item?.id)?.selectedData;
    if (!data) return null;
    const visibleData = data.slice(0, 4);
    const remainingCount = data.length - 4;
    return (
      <>
        {visibleData.map((ele) => (
          <span className="choosed-option" key={ele?.id}>
            <span>{truncateText(ele?.label)}</span>
            <img
              src={CrossImage}
              alt="cross"
              style={{ height: "9px", cursor: "pointer" }}
              onClick={() => handleRemoveData(ele, item?.id, item?.setState)}
            />
          </span>
        ))}
        {remainingCount > 0 && (
          <span className="choosed-option">+{remainingCount}</span>
        )}
      </>
    );
  };

  useEffect(() => {
    setCommonData(filterData);
    setFilteredData(filterData);
    const initialSelectedData = [];
    if (filterData?.length > 0) {
      filterData.forEach((item) => {
        const value = item.value;
        if (item.type === "input") {
          if (value) {
            if (item.data) {
              if (Array.isArray(value)) {
                // Handle multiselect values
                const defaultOptions = item.data.filter((option) =>
                  value.includes(option?._id)
                );
                if (defaultOptions.length > 0) {
                  initialSelectedData.push({
                    id: item.id,
                    selectedData: defaultOptions,
                  });
                }
              } else {
                // Handle single select values
                const defaultOption = item.data.find(
                  (option) => option?._id === value
                );
                if (defaultOption) {
                  initialSelectedData.push({
                    id: item.id,
                    selectedData: [defaultOption],
                  });
                }
              }
            }
          }
        } else if (item.type === "noDefaultDate") {
          if (value && value[0] && value[1]) {
            setInputValues((prev) => ({ ...prev, [item.id]: value }));
          }
        }
      });
    }
    setSelectedData(initialSelectedData);
  }, [filterData]);

  useEffect(() => {
    Object.keys(inputValues).forEach((id) => {
      const existData = commonData?.find((item) => item?.id === Number(id));
      if (!existData) return;

      const updatedData = existData?.data?.filter((ele) =>
        ele?.label
          ?.toLocaleLowerCase()
          ?.includes(
            inputValues[id] ? inputValues[id] : ""?.toLocaleLowerCase()
          )
      );

      setFilteredData((prev) =>
        prev.map((item) =>
          item.id === Number(id) ? { ...item, data: updatedData } : item
        )
      );
    });
  }, [inputValues]);

  const handleMonthChange = (date, id, setDate) => {
    markUserAction();
    setSelectedDate(date);
    if (setDate) {
      setDate(date);
    }
  };

  useEffect(() => {
    if (!autoApply || !handleSaveAllFilter) {
      return;
    }

    if (!isUserActionRef.current) {
      return;
    }

    isUserActionRef.current = false;
    handleSaveAllFilter();
  }, [autoApply, handleSaveAllFilter, selectedData, inputValues, selectedDate]);

  return (
    <main
      className="filter-box-scroll"
      style={
        horizontalLayout
          ? {
            position: "relative",
            zIndex: 1,
            overflow: "visible",
            maxHeight: "none",
          }
          : {}
      }
    >
      <div
        className="filter-box-content"
        style={
          horizontalLayout
            ? {
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              alignItems: "flex-start",
              position: "relative",
              overflow: "visible",
              overflowY: "visible",
              border: hideHeader ? "none" : "1px solid #D0D5DD",
              borderRadius: hideHeader ? "0px" : "8px",
              padding: hideHeader ? "0px" : "16px",
              background: hideHeader ? "transparent" : "#ffffff",
              boxSizing: "border-box",
            }
            : {}
        }
      >
        {horizontalLayout && !hideHeader && (
          <div
            style={{
              fontSize: "20px",
              fontWeight: 700,
              color: "#344054",
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
                flex: 1,
              }}
            >
              <span
                style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "8px" }}
                onClick={() => setIsCardOpen(!isCardOpen)}
              >
                <img src={FilterIcon} alt="filter" style={{ height: "16px", width: "16px" }} />
                Filters ({
                  (() => {
                    const count = filterData?.filter(item => {
                      console.log('Filter item:', item.id, 'value:', item.value, 'type:', item.type, 'inputValue:', inputValues[item.id]);

                      // For date filters (noDefaultDate type), check inputValues
                      if (item.type === 'noDefaultDate' || item.type === 'date' || item.type === 'month') {
                        const dateValue = inputValues[item.id] || item.value;
                        if (dateValue !== undefined && dateValue !== null) {
                          if (Array.isArray(dateValue)) {
                            const hasValue = dateValue.length > 0 && dateValue[0] !== null;
                            console.log('Date filter', item.id, 'hasValue:', hasValue);
                            return hasValue;
                          }
                        }
                        return false;
                      }

                      // For other filters with value prop
                      if (item.value !== undefined && item.value !== null) {
                        // For arrays
                        if (Array.isArray(item.value)) {
                          const hasValue = item.value.length > 0 && item.value[0] !== null;
                          console.log('Array filter', item.id, 'hasValue:', hasValue);
                          return hasValue;
                        }
                        // For single values
                        const hasValue = item.value !== '';
                        console.log('Single value filter', item.id, 'hasValue:', hasValue);
                        return hasValue;
                      }

                      // For dropdown/multi-select filters, check selectedData
                      const selected = selectedData?.find(s => s.id === item.id);
                      const hasSelected = selected && selected.selectedData && selected.selectedData.length > 0;
                      console.log('Dropdown filter', item.id, 'hasSelected:', hasSelected);
                      return hasSelected;
                    }).length || 0;
                    console.log('Total filter count:', count);
                    return count;
                  })()
                })
              </span>

            </div>
            <span
              style={{ fontSize: "14px", fontWeight: 400, cursor: "pointer" }}
              onClick={() => setIsCardOpen(!isCardOpen)}
            >
              {isCardOpen ? (
                <img
                  src={UpVectorImg}
                  style={{ height: "6px", width: "12px" }}
                  alt="up-vector"
                />
              ) : (
                <img
                  src={DownVectorImg}
                  style={{ height: "6px", width: "12px" }}
                  alt="down-vector"
                />
              )}
            </span>
          </div>
        )}
        {(isCardOpen || (horizontalLayout && hideHeader)) && (
          <div
            className={horizontalLayout ? "FilterBoxBody" : undefined}
            style={
              horizontalLayout
                ? {
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  gap: "16px",
                  alignItems: "flex-start",
                  width: "calc(100% - 32px)",
                  marginLeft: "16px",
                  marginRight: "16px",
                  borderTop: "1px solid #E4E7EC",
                  paddingTop: "16px",
                  boxSizing: "border-box",
                }
                : {}
            }
          >
            {commonData?.map((item) => {
              return (
                <div
                  className={horizontalLayout ? "" : "filter-actions-container"}
                  key={item?.id}
                  style={
                    horizontalLayout
                      ? {
                        flex: "0 1 auto",
                        minWidth: "200px",
                        maxWidth: horizontalLayout ? "300px" : "100%",
                        position: "relative",
                        zIndex: openDataMenu[item?.id] ? 1300 : 1,
                        backgroundColor: "transparent",
                        width: horizontalLayout ? "300px" : "100%",
                        padding: "0px",
                        boxSizing: "border-box",
                      }
                      : {}
                  }
                >
                  <div
                    className={
                      horizontalLayout ? "" : "filter-drop-down-container"
                    }
                    style={
                      horizontalLayout
                        ? {
                          display: "grid",
                          gap: "10px",
                          minHeight: "auto",
                          backgroundColor: "transparent",
                          width: "100%",
                          boxSizing: "border-box",
                        }
                        : {}
                    }
                  >
                    {!alwaysOpen && (
                      <div className="filter-drop-down">
                        <span
                          style={{ fontSize: "14px", width: "100%" }}
                          onClick={() => handleOpenClose(item)}
                        >
                          {item?.label}
                        </span>
                        <div className="drop-down">
                          {clearView[item?.id] && existViw[item?.id] && (
                            <span
                              className="clearBtn"
                              onClick={() => handleClear(item?.id)}
                            >
                              Clear
                            </span>
                          )}
                          <span
                            onClick={() => handleOpenClose(item)}
                            style={{
                              width: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {!existViw[item.id] ? (
                              <>
                                <img
                                  src={DownVectorImg}
                                  style={{ height: "6px", width: "12px" }}
                                  alt="down-vector"
                                />
                              </>
                            ) : (
                              <>
                                <img
                                  src={UpVectorImg}
                                  style={{ height: "6px", width: "12px" }}
                                  alt="up-vector"
                                />
                              </>
                            )}
                          </span>
                        </div>
                      </div>
                    )}
                    {alwaysOpen &&
                      item?.type !== "noDefaultDate" &&
                      item?.type !== "normalInput" &&
                      item?.type !== "button" && (
                        <div
                          style={{
                            fontSize: "14px",
                            fontWeight: 500,
                            marginBottom: "8px",
                            color: "#344054",
                            padding: "8px 12px",
                            border: "1px solid #D0D5DD",
                            borderRadius: "4px",
                            backgroundColor: openDataMenu[item?.id]
                              ? "#F9FAFB"
                              : "#fff",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            position: "relative",
                            width: "100%",
                            maxWidth: "100%",
                            boxSizing: "border-box",
                            overflow: "hidden",
                          }}
                        >
                          {(() => {
                            const selected = selectedData?.find(
                              (d) => d?.id === item?.id
                            )?.selectedData;

                            if (selected && selected.length > 0) {
                              return (
                                <div
                                  style={{
                                    flex: 1,
                                    display: "flex",
                                    alignItems: "center",
                                    fontSize: "14px",
                                    cursor: "pointer",
                                    overflow: "hidden",
                                    whiteSpace: "nowrap",
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setOpenDataMenu((prev) => ({
                                      ...prev,
                                      [item.id]: true,
                                    }));
                                  }}
                                >
                                  {selected.length > 1 ? (
                                    <>
                                      <span
                                        style={{
                                          marginRight: "4px",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                        }}
                                      >
                                        {selected[0]?.label}
                                      </span>
                                      <span
                                        style={{
                                          backgroundColor: "#F2F4F7",
                                          color: "#344054",
                                          padding: "2px 8px",
                                          borderRadius: "16px",
                                          fontSize: "12px",
                                          fontWeight: 500,
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        + {selected.length - 1} Selected
                                      </span>
                                    </>
                                  ) : (
                                    <span
                                      style={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                      }}
                                    >
                                      {selected[0]?.label}
                                    </span>
                                  )}
                                </div>
                              );
                            }

                            return (
                              <input
                                type="text"
                                style={{
                                  border: "none",
                                  outline: "none",
                                  background: "transparent",
                                  fontSize: "14px",
                                  flex: 1,
                                  minWidth: 0,
                                  cursor: "text",
                                  padding: 0,
                                }}
                                placeholder={item?.label}
                                value={inputValues[item.id] || ""}
                                onChange={(e) => {
                                  handleInputValues(e, item?.id);
                                  handleOnChange(e, item?.id);
                                }}
                                onFocus={() => {
                                  setOpenDataMenu((prev) => ({
                                    ...prev,
                                    [item.id]: true,
                                  }));
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setOpenDataMenu((prev) => ({
                                    ...prev,
                                    [item.id]: true,
                                  }));
                                }}
                              />
                            );
                          })()}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              flexShrink: 0,
                            }}
                          >
                            {(() => {
                              const selected = selectedData?.find(
                                (d) => d?.id === item?.id
                              )?.selectedData;
                              if (selected && selected.length > 0) {
                                return (
                                  <img
                                    src={CrossImage}
                                    alt="clear"
                                    style={{
                                      height: "12px",
                                      width: "12px",
                                      cursor: "pointer",
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setSelectedData((prev) =>
                                        prev.map((itm) =>
                                          itm?.id === item?.id
                                            ? {
                                              ...itm,
                                              selectedData: [],
                                            }
                                            : itm
                                        )
                                      );
                                      // Clear the input value
                                      setInputValues((prev) => ({
                                        ...prev,
                                        [item.id]: null,
                                      }));
                                      // Clear the state first
                                      item?.setState(null);
                                      // Use the dedicated clear function if available, otherwise fallback to handleSaveAllFilter
                                      if (handleClearSingleFilter) {
                                        handleClearSingleFilter(item?.id);
                                      } else if (
                                        handleSaveAllFilter &&
                                        !autoApply
                                      ) {
                                        // Only call directly if autoApply is false (manual mode)
                                        // The useEffect will handle it when selectedData changes if autoApply is true
                                        setTimeout(() => {
                                          handleSaveAllFilter();
                                        }, 200);
                                      }
                                    }}
                                  />
                                );
                              }
                              return null;
                            })()}
                            <span
                              style={{ fontSize: "10px", cursor: "pointer" }}
                              onClick={() => {
                                setOpenDataMenu((prev) => ({
                                  ...prev,
                                  [item.id]: !prev[item.id],
                                }));
                              }}
                            >
                              {openDataMenu[item?.id] ? (
                                <img
                                  src={UpVectorImg}
                                  style={{ height: "6px", width: "12px" }}
                                  alt="up-vector"
                                />
                              ) : (
                                <img
                                  src={DownVectorImg}
                                  style={{ height: "6px", width: "12px" }}
                                  alt="down-vector"
                                />
                              )}
                            </span>
                          </div>
                        </div>
                      )}
                    {alwaysOpen && item?.type === "noDefaultDate" && (
                      <div
                        style={{
                          fontSize: "14px",
                          fontWeight: 500,
                          marginBottom: "8px",
                          color: "#344054",
                          cursor: "pointer",
                          padding: "8px 12px",
                          border: "1px solid #D0D5DD",
                          borderRadius: "4px",
                          backgroundColor: "#fff",
                          display: "flex",
                          alignItems: "center",
                          position: "relative",
                          height: "40px",
                          boxSizing: "border-box",
                        }}
                      >
                        <div
                          style={{
                            flex: 1,
                            position: "relative",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <RangePicker
                            placement="bottomLeft"
                            className="Range_Picker w-100"
                            style={{
                              borderRadius: "0px",
                              width: "100%",
                              border: "none",
                              padding: 0,
                              height: "24px",
                              lineHeight: "24px",
                            }}
                            inputStyle={{
                              height: "24px",
                              lineHeight: "24px",
                              fontSize: "14px",
                              padding: 0,
                            }}
                            value={inputValues[item.id] || item.defaultValue}
                            onChange={(e) => {
                              handleDateChangeDefaultNoDate(
                                e,
                                item?.id,
                                item?.setDate
                              );
                            }}
                            format="DD/MM/YYYY"
                            placeholder={["Start date", "End date"]}
                            allowClear={false}
                            bordered={false}
                          />
                        </div>
                        {(inputValues[item.id] || item.defaultValue) && (
                          <img
                            src={CrossImage}
                            alt="clear"
                            style={{
                              height: "12px",
                              width: "12px",
                              cursor: "pointer",
                              marginLeft: "8px",
                              flexShrink: 0,
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setInputValues((prev) => ({
                                ...prev,
                                [item.id]: null,
                              }));
                              if (item?.setDate) {
                                item.setDate(null);
                              }
                              if (handleClearSingleFilter) {
                                handleClearSingleFilter(item?.id);
                              } else if (handleSaveAllFilter && !autoApply) {
                                // Only call directly if autoApply is false (manual mode)
                                // The useEffect will handle it when selectedData changes if autoApply is true
                                setTimeout(() => {
                                  handleSaveAllFilter();
                                }, 200);
                              }
                            }}
                          />
                        )}
                      </div>
                    )}
                    {alwaysOpen && item?.type === "normalInput" && (
                      <div
                        style={{
                          fontSize: "14px",
                          fontWeight: 500,
                          marginBottom: "8px",
                          color: "#344054",
                          padding: "8px 12px",
                          border: "1px solid #D0D5DD",
                          borderRadius: "4px",
                          backgroundColor: "#fff",
                          display: "flex",
                          alignItems: "center",
                          position: "relative",
                          height: "40px",
                          boxSizing: "border-box",
                        }}
                      >
                        <input
                          type="text"
                          className="search-input"
                          style={{
                            flex: 1,
                            border: "none",
                            outline: "none",
                            fontSize: "14px",
                            padding: 0,
                            height: "24px",
                            lineHeight: "24px",
                            backgroundColor: "transparent",
                          }}
                          placeholder={`Enter ${item?.label?.toLowerCase() || "value"
                            }`}
                          value={inputValues[item.id] || item.value || ""}
                          onChange={(e) => {
                            handleInputValues(e, item?.id);
                            handleOnChange(e, item?.id);
                            handleOnEnter(e, item?.setState);
                          }}
                          onFocus={() =>
                            setOpenDataMenu((prev) => ({
                              ...prev,
                              [item.id]: true,
                            }))
                          }
                        />
                        {(inputValues[item.id] || item.value) && (
                          <img
                            src={CrossImage}
                            alt="clear"
                            style={{
                              height: "12px",
                              width: "12px",
                              cursor: "pointer",
                              marginLeft: "8px",
                              flexShrink: 0,
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setInputValues((prev) => ({
                                ...prev,
                                [item.id]: null,
                              }));
                              if (item?.setState) {
                                item.setState("");
                              }
                              if (handleClearSingleFilter) {
                                handleClearSingleFilter(item?.id);
                              } else if (handleSaveAllFilter && !autoApply) {
                                setTimeout(() => {
                                  handleSaveAllFilter();
                                }, 200);
                              }
                            }}
                          />
                        )}
                      </div>
                    )}
                    {alwaysOpen && item?.type === "button" && (
                      <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                        {item.data.map((button, index) => (
                          <Button
                            variant={
                              selectedButton === button.value
                                ? "contained"
                                : "outlined"
                            }
                            style={{
                              backgroundColor:
                                selectedButton === button.value
                                  ? "#008CBA"
                                  : "#fff",
                              color:
                                selectedButton === button.value
                                  ? "#fff"
                                  : "#008CBA",
                              border: "1px solid #008CBA",
                              fontWeight: 600,
                              marginRight: 8,
                              height: "40px",
                            }}
                            onClick={() => handleButtonClick(button.value)}
                            key={index}
                          >
                            {button.label}
                          </Button>
                        ))}
                      </div>
                    )}
                    {existViw[item?.id] &&
                      !(
                        alwaysOpen &&
                        (item?.type === "noDefaultDate" ||
                          item?.type === "normalInput" ||
                          item?.type === "button")
                      ) && (
                        <>
                          {item.type === "input" ? (
                            <>
                              {!hideInput && (
                                <div className="search-bar">
                                  <input
                                    className="search-input"
                                    onChange={(e) => {
                                      console.log("onChange ", e);
                                      handleInputValues(e, item?.id);
                                      handleOnChange(e, item?.id);
                                    }}
                                    value={
                                      inputValues[item.id]
                                        ? inputValues[item.id]
                                        : ""
                                    }
                                    onFocus={() =>
                                      setOpenDataMenu((prev) => ({
                                        ...prev,
                                        [item.id]: true,
                                      }))
                                    }
                                  />
                                  <div
                                    style={{
                                      fontSize: "14px",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      width: "20%",
                                    }}
                                  >
                                    <span>Enter</span>
                                    <span>
                                      <img
                                        src={EnterVectorImg}
                                        style={{
                                          height: "10px",
                                          width: "14px",
                                        }}
                                        alt="enter-vector"
                                      />
                                    </span>
                                  </div>
                                </div>
                              )}
                            </>
                          ) : item.type === "normalInput" ? (
                            <>
                              <div className="search-bar">
                                <input
                                  className="search-input"
                                  onChange={(e) => {
                                    handleInputValues(e, item?.id);
                                    handleOnChange(e, item?.id);
                                    handleOnEnter(e, item?.setState);
                                  }}
                                  value={
                                    inputValues[item.id]
                                      ? inputValues[item.id]
                                      : ""
                                  }
                                  onFocus={() =>
                                    setOpenDataMenu((prev) => ({
                                      ...prev,
                                      [item.id]: true,
                                    }))
                                  }
                                />
                                <div
                                  style={{
                                    fontSize: "14px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    width: "20%",
                                  }}
                                >
                                  <span>Enter</span>
                                  <span>
                                    <img
                                      src={EnterVectorImg}
                                      style={{
                                        height: "10px",
                                        width: "14px",
                                      }}
                                      alt="enter-vector"
                                    />
                                  </span>
                                </div>
                              </div>
                            </>
                          ) : item?.type === "noDefaultDate" ? (
                            <>
                              <div>
                                <RangePicker
                                  placement="bottomLeft"
                                  className="Range_Picker w-100"
                                  style={{ borderRadius: "0px" }}
                                  value={
                                    inputValues[item.id] || item.defaultValue
                                  }
                                  onChange={(e) => {
                                    handleDateChangeDefaultNoDate(
                                      e,
                                      item?.id,
                                      item?.setDate
                                    );
                                  }}
                                  format="DD/MM/YYYY"
                                  placeholder="Select date range"
                                  cleanable
                                />
                              </div>
                            </>
                          ) : item.type === "month" ? (
                            <>
                              <LocalizationProvider
                                dateAdapter={AdapterDateFns}
                              >
                                <div>
                                  <DatePicker
                                    value={selectedDate}
                                    onChange={(e) =>
                                      handleMonthChange(
                                        e,
                                        item?.id,
                                        item?.setDate
                                      )
                                    }
                                    views={["year", "month"]}
                                    format="yyyy-MM"
                                    placeholder="Select month"
                                    placement="auto"
                                    cleanable
                                    style={{ width: "100%" }}
                                  />
                                </div>
                              </LocalizationProvider>
                            </>
                          ) : item.type === "button" ? (
                            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                              {item.data.map((button, index) => (
                                <Button
                                  variant={
                                    selectedButton === button.value
                                      ? "contained"
                                      : "outlined"
                                  }
                                  style={{
                                    backgroundColor:
                                      selectedButton === button.value
                                        ? "#008CBA"
                                        : "#fff",
                                    color:
                                      selectedButton === button.value
                                        ? "#fff"
                                        : "#008CBA",
                                    border: "1px solid #008CBA",
                                    fontWeight: 600,
                                    marginRight: 8,
                                    height: "40px",
                                  }}
                                  onClick={() =>
                                    handleButtonClick(button.value)
                                  }
                                  key={index}
                                >
                                  {button.label}
                                </Button>
                              ))}
                            </div>
                          ) : (
                            <>
                              <div>
                                <DateRangePicker
                                  value={
                                    inputValues[item.id]
                                      ? inputValues[item.id]
                                      : [new Date(), new Date()]
                                  }
                                  onChange={(e) =>
                                    handleDateChange(e, item?.id, item?.setDate)
                                  }
                                  style={{ width: "100%" }}
                                  format="yyyy-MM-dd"
                                  placeholder="Select date range"
                                  placement="auto"
                                  cleanable
                                />
                              </div>
                            </>
                          )}
                        </>
                      )}
                    {item?.type !== "normalInput" && existViw[item?.id] && (
                      <>
                        {!openDataMenu[item?.id] && !horizontalLayout ? (
                          <>
                            <div className="choosed-option-container">
                              {handleDataSizing(item)}
                            </div>
                          </>
                        ) : openDataMenu[item?.id] ? (
                          <ClickAwayListener
                            onClickAway={() => {
                              if (horizontalLayout && alwaysOpen) {
                                setOpenDataMenu((prev) => ({
                                  ...prev,
                                  [item.id]: false,
                                }));
                              }
                            }}
                          >
                            <div
                              style={
                                horizontalLayout
                                  ? {
                                    position: "absolute",
                                    top: "100%",
                                    left: 0,
                                    right: 0,
                                    zIndex: 1300,
                                    marginTop: "4px",
                                    backgroundColor: "transparent",
                                  }
                                  : {}
                              }
                            >
                              <div
                                className={
                                  horizontalLayout ? "" : "data-container"
                                }
                                style={
                                  horizontalLayout
                                    ? {
                                      position: "relative",
                                      width: "100%",
                                      maxHeight: "300px",
                                      overflowY: "auto",
                                      backgroundColor: "#ffffff",
                                      boxShadow:
                                        "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                      borderRadius: "4px",
                                      border: "1px solid #E4E7EC",
                                      isolation: "isolate",
                                      minHeight: "auto",
                                      maxHeight: "300px",
                                      padding: "4px 0px",
                                    }
                                    : {}
                                }
                              >
                                {(() => {
                                  const currentData = filteredData?.find(
                                    (e) => e?.id === item?.id
                                  )?.data;

                                  if (currentData?.length > 0) {
                                    return currentData.map((ele) => (
                                      <div
                                        className={horizontalLayout ? "" : "data"}
                                        key={ele?._id}
                                        onClick={(e) => {
                                          handleSelectData(
                                            ele,
                                            item?.setState,
                                            item?.id,
                                            item?.variation
                                          );
                                          // Close dropdown after selection in horizontal layout
                                          if (
                                            horizontalLayout &&
                                            alwaysOpen &&
                                            item?.variation !== "multiple"
                                          ) {
                                            setOpenDataMenu((prev) => ({
                                              ...prev,
                                              [item.id]: false,
                                            }));
                                          }
                                        }}
                                        style={{
                                          ...(horizontalLayout
                                            ? {
                                              width: "100%",
                                              textAlign: "left",
                                              boxSizing: "border-box",
                                              padding: "8px 12px",
                                              overflow: "hidden",
                                              position: "relative",
                                              zIndex: 1301,
                                              textOverflow: "ellipsis",
                                              fontSize: "14px",
                                              color: "#2d2926",
                                              backgroundColor: "#ffffff",
                                              cursor: "pointer",
                                              minHeight: "auto",
                                            }
                                            : {
                                              backgroundColor: "transparent",
                                            }),
                                        }}
                                        onMouseEnter={(e) => {
                                          if (horizontalLayout) {
                                            e.currentTarget.style.backgroundColor =
                                              "#F9FAFB";
                                          }
                                        }}
                                        onMouseLeave={(e) => {
                                          if (horizontalLayout) {
                                            e.currentTarget.style.backgroundColor =
                                              "#ffffff";
                                          }
                                        }}
                                      >
                                        {ele?.label}
                                      </div>
                                    ));
                                  } else {
                                    return (
                                      <div
                                        style={{
                                          padding: "8px 12px",
                                          fontSize: "14px",
                                          color: "#667085",
                                          textAlign: "center",
                                        }}
                                      >
                                        No options
                                      </div>
                                    );
                                  }
                                })()}
                              </div>
                            </div>
                          </ClickAwayListener>
                        ) : null}
                      </>
                    )}
                  </div>
                </div>
              );
            })}
            {horizontalLayout && !hideActionButtons && (
              <div style={{ display: "flex", gap: "8px", alignItems: "center", marginLeft: "auto" }}>
                {!hideDefaultButtons && (
                  <>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        if (handleSaveAllFilter) {
                          handleSaveAllFilter();
                        }
                      }}
                      style={{
                        padding: "10px 16px",
                        fontSize: "14px",
                        fontWeight: 500,
                        color: "#ffffff",
                        backgroundColor: "#1E3A5F",
                        border: "none",
                        borderRadius: "6px",
                        cursor: "pointer",
                        transition: "background-color 0.2s",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#2E5A8F";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "#1E3A5F";
                      }}
                    >
                      Search
                    </button>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleClearAll();
                      }}
                      style={{
                        padding: "10px 16px",
                        fontSize: "14px",
                        fontWeight: 500,
                        color: "#344054",
                        backgroundColor: "#ffffff",
                        border: "1px solid #D0D5DD",
                        borderRadius: "6px",
                        cursor: "pointer",
                        transition: "background-color 0.2s",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#F9FAFB";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "#ffffff";
                      }}
                    >
                      Clear All
                    </button>
                  </>
                )}
                {customActionButtons && customActionButtons}
              </div>
            )}
          </div>
        )}
      </div>
    </main>
  );
};
export default FilterBox;
